// PLACE SLOT MODULE INSIDE THE LP
// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER


//
// =PLACE SLOT MODULE INSIDE THE LP
// --------------------------------------------------

const sliderSlot = document.getElementById('msdwSlidetSlot1');
const catLandingMiddle = document.getElementById('cat-landing-middle');
catLandingMiddle && sliderSlot.appendChild(catLandingMiddle);

const sliderSlot2 = document.getElementById('msdwSlidetSlot2');
const catLandingBottom1 = document.getElementById('cat-landing-bottom1');
catLandingBottom1 && sliderSlot2.appendChild(catLandingBottom1);

const sliderSlot3 = document.getElementById('msdwSlidetSlot3');
const catLandingBottom2 = document.getElementById('cat-landing-bottom2');
catLandingBottom2 && sliderSlot3.appendChild(catLandingBottom2);


//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

var offsetValue = 76;
if ( window.innerWidth <= 899 ) {
  offsetValue;
  // console.log(offsetValue);
} else {
  offsetValue = 75;
  // console.log(offsetValue);
}

document.getElementsByTagName('html')[0].style.scrollBehavior = "unset";

// smooth scroll
function smoothScrollTo(target, offset = 0, duration = 1000) {
  // if target is a selector string, resolve it
  const element = typeof target === 'string'
    ? document.querySelector(target)
    : target;

  // guard against nulls or invalid types
  if (!element || !element.getBoundingClientRect) {
    console.warn('smoothScrollTo: invalid target', target);
    return;
  }

  const startY = window.pageYOffset;
  const targetY = element.getBoundingClientRect().top + startY - offset;
  const distance = targetY - startY;
  const startTime = performance.now();

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  function step(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easeInOutQuad(progress);
    window.scrollTo(0, startY + distance * eased);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}

document.querySelectorAll('.msdw-page-scroll').forEach(function (link) {
  link.addEventListener('click', function (e) {
    // Same-page links only
    if (
      location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '') &&
      location.hostname === link.hostname
    ) {
      let target = document.querySelector(link.hash);
      if (!target) {
        target = document.querySelector('[name="' + link.hash.slice(1) + '"]');
      }

      if (target) {
        e.preventDefault(); // stop default jump
        smoothScrollTo(target, offsetValue, 750);
      }
    }
  });
});


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

Splitting();

const scroll = window.requestAnimationFrame;

function showOnScroll() {
  const elems = document.querySelectorAll(
    ".msdw-animate, .msdw-anim-skew, .msdw-anim-zoom"
  );

  elems.forEach((el) => {
    const elPosition = el.getBoundingClientRect().top;
    const elScreen = window.innerHeight / 0.9;

    if (elPosition < elScreen) {
      el.classList.add("msdw-animated");
    }
  });

  scroll(showOnScroll);
}

showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const sliders = document.querySelectorAll('.msdw-product-slider');

for (let i = 0; i < sliders.length; i++) {
  new Swiper(`.msdw-product-slider-${i + 1}`, {
    slidesPerView: 2,
    spaceBetween: 10,
    loop: false,
    navigation: false,
    pagination: {
      el: `.msdw-swiper-pagination-${i + 1}`,
      type: "progressbar",
    },
    navigation: {
      enable: false,
      prevEl: `.msdw-swiper-button-prev-${i + 1}`,
      nextEl: `.msdw-swiper-button-next-${i + 1}`,
    },
    breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 15,
        pagination: false,
        navigation: true,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });
}


//
// =SLIDER (SLICK JS)
// --------------------------------------------------

// $('.msdw-slider-jacket').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   swipe: false,
//   arrows: false,
//   swipeToSlide: true,   // in case, 2 or more slides at a time
//   autoplay: true,       // if autoplay...
//   accessibility: false  // use this to avoid page jumping bug
// });

// $('.slick-prev').click(function() {
//   $('.msdw-slider-jacket').slick('slickPrev');
// });
//
// $('.slick-next').click(function() {
//   $('.msdw-slider-jacket').slick('slickNext');
// });

// UNSLICK
// If needed, here's a fix for window resizing
// $(window).on('orientationchange resize', function() {
//   $('.msdw-slider-jacket').slick('resize');
// });


//
// =PRODUCT PICKER
// --------------------------------------------------

// const productPickers = document.querySelectorAll('.msdw-product-detail-picker');

// productPickers.forEach(productPicker => {
//   const productIdNumber = productPicker.dataset.productId;
//   productPicker.addEventListener('click', (e) => {
//     e.preventDefault();
//     window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {
//       'productId': productIdNumber
//     });
//   });
// });


//
// =NEWSLETTER PICKER
// --------------------------------------------------

// var campaignId = 'familyAndFriends',
//     pickerTag = document.getElementById("openPicker"),
//     newsletterConfig = {},
//     baseUrl = jwsdwSettings.baseUrl;

// $.ajax({
//   type: 'GET',
//   url: baseUrl + '/Newsletter-getNewsletterConfig',
//   data: {
//     campaignId: campaignId
//   },
//   success: function(response) {
//     newsletterConfig = response
//   },
//   error: function(response) {
//     jwsdwApi.popup.showHttpError(response.status)
//   }
// });

// pickerTag.addEventListener("click", function(){
//   window.jwsdwMediator.publish('openPicker', 'newsletterSignupPicker', {
//     "campaign": newsletterConfig.id,
//     "introduction": newsletterConfig.introduction,
//     "disclaimerOne": newsletterConfig.disclaimerOne,
//     "disclaimerTwo": newsletterConfig.disclaimerTwo
//   });
// });
